import type { AdminCourseScheduleItemType } from '@duke-hq/shared-constants/course';

export type ScheduleBlock = {
  unit: AdminCourseScheduleItemType | null;
  children: AdminCourseScheduleItemType[];
};

// Group the flat schedule into unit blocks for display: each UNIT starts a block and the
// conversations/assessments that follow attach to it. Items before the first unit fall into a
// leading block with no unit. Order is preserved so the flat array round-trips unchanged.
export function groupScheduleItems(items: AdminCourseScheduleItemType[]): ScheduleBlock[] {
  const blocks: ScheduleBlock[] = [];
  let current: ScheduleBlock | null = null;

  for (const item of items) {
    if (item.type === 'UNIT') {
      current = { unit: item, children: [] };
      blocks.push(current);
      continue;
    }

    if (current === null) {
      current = { unit: null, children: [] };
      blocks.push(current);
    }
    current.children.push(item);
  }

  return blocks;
}
